export default "__VITE_ASSET__IMGKGtlV__"